// Labels change while the chart moves; the cache is dropped when it grows past this
const MAX_CACHED_WIDTHS = 2000;

/**
 * Measures text width with a cache: axis labels repeat from frame to frame.
 *
 * @param {CanvasRenderingContext2D} context
 * @returns {{ measure: (text: string, font: string) => number, clear: () => void }}
 */
export const createTextMeasurer = (context) => {
  const widths = new Map();

  return {
    measure: (text, font) => {
      const key = `${font}|${text}`;
      let width = widths.get(key);

      if (width === undefined) {
        context.font = font;
        width = context.measureText(text).width;

        if (widths.size >= MAX_CACHED_WIDTHS) widths.clear();

        widths.set(key, width);
      }

      return width;
    },
    clear: () => widths.clear(),
  };
};
